export default __webpack_public_path__ + "static/media/grid12.7b2a6cd6.png";